module.exports = __webpack_public_path__ + "static/Gle Limousine-0bb278defc1c84ef83741ad19f65482b.jpg";